import { WorkflowConfigurations, WorkflowStep } from "../types/workflow.types";

const singleCellSteps: WorkflowStep[] = [
  {
    id: "quality-control",
    title: "Quality Control",
    description: "Checks the quality of your data",
    status: "pending",
  },
  {
    id: "filter-cells-genes",
    title: "Filter Cells & Genes",
    description: "Choose one of two alternatives",
    status: "pending",
  },
  // {
  //   id: "doublet-detection",
  //   title: "Doublet Detection (Optional)",
  //   description: "Identify and remove doublets - can be skipped",
  //   status: "pending",
  // },
  {
    id: "normalization",
    title: "Normalization",
    description: "Normalize gene expression data",
    status: "pending",
  },
  {
    id: "feature-selection",
    title: "Feature Selection",
    description: "Select highly variable genes",
    status: "pending",
  },
  {
    id: "dimensionality-reduction",
    title: "Dimensionality Reduction",
    description: "Reduce dimensions using PCA",
    status: "pending",
  },
  {
    id: "umap",
    title: "UMAP",
    description: "Visualize data in 2D space",
    status: "pending",
  },
  {
    id: "clustering",
    title: "Clustering",
    description: "Cluster cells into groups",
    status: "pending",
  },
  {
    id: "cell-type-annotation",
    title: "Cell Type Annotation",
    description: "Annotate cell types using reference data",
    status: "pending",
  },
  {
    id: "marker-gene-set",
    title: "Cell Type Identification",
    description: "Explore known marker genes across clusters",
    status: "pending",
  },
  {
    id: "de-genes-markers",
    title: "Cell Type Markers & Biomarker Discovery",
    description: "Identify genes that differ between biological groups and evaluate their predictive potential.",
    status: "pending",
  },
  {
    id: "enrichment",
    title: "Biological Pathways & Processes",
    description: "Discover biological pathways, processes, and functions associated with your selected genes.",
    status: "pending",
  },
  {
    id: "trajectory-analysis",
    title: "Trajectory Analysis",
    description: "Infer cell-state progression with PAGA and DPT pseudotime",
    status: "pending",
  },
];

export const workflowConfigurations: WorkflowConfigurations = {
  "single-cell": {
    stepOrder: singleCellSteps.map((step) => step.id),
    stepNameMapping: {
      "quality-control": "Quality Control",
      "filter-cells-genes": "Filter Cells & Genes",
      "doublet-detection": "Doublet Detection",
      normalization: "Normalization",
      "feature-selection": "Feature Selection",
      "dimensionality-reduction": "Dimensionality Reduction",
      umap: "Umap",
      clustering: "Clustering",
      "cell-type-annotation": "Cell Type Annotation",
      "marker-gene-set": "Marker Gene Set",
      "de-genes-markers": "De Genes As Markers",
      enrichment: "Enrichment",
      "trajectory-analysis": "Trajectory Analysis",
    } as Record<string, string>,
    steps: singleCellSteps,
  },
  // Future data types can be added here:
  // 'bulk-rna': {
  //   stepOrder: [...],
  //   stepNameMapping: {...},
  //   steps: [...]
  // },
  // 'proteomics': {
  //   stepOrder: [...],
  //   stepNameMapping: {...},
  //   steps: [...]
  // },
  // 'metabolomics': {
  //   stepOrder: [...],
  //   stepNameMapping: {...},
  //   steps: [...]
  // }
};

export const getWorkflowConfiguration = (dataType: string) => {
  return (
    workflowConfigurations[dataType] || workflowConfigurations["single-cell"]
  );
};
